interface LineSeparatedProps {
  keyy: React.ReactNode;
  value: React.ReactNode;
}

export function LineSeparated({ keyy, value }: LineSeparatedProps) {
  return (
    <div>
      <dt className="text-sm font-medium text-gray-500">{keyy}</dt>
      <dd className="text-sm text-gray-900">{value}</dd>
    </div>
  );
}
